import React from "react";

const Info = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className="fill-current stroke-current"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <circle stroke="currentColor" strokeWidth="2" cx="14" cy="14" r="13" />
      <rect fill="currentColor" x="12.75" y="13" width="2.5" height="8" />
      <rect fill="currentColor" x="12.75" y="8" width="2.5" height="2.5" />
    </g>
  </svg>
);

export default Info;
